
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServiceSectors from './components/ServiceSectors';
import ServicesGrid from './components/ServicesGrid';
import WhyChooseUs from './components/WhyChooseUs';
import Testimonials from './components/Testimonials';
import CTABanner from './components/CTABanner';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <ServiceSectors />
      <ServicesGrid />
      <WhyChooseUs />
      <Testimonials />
      <CTABanner />
      <Footer />
    </div>
  );
};

export default HomePage;
